/* eslint-disable react/no-array-index-key */
import React, { useEffect, useRef } from 'react'
import { PieChart, Pie, Cell, Legend, Tooltip, Label } from 'recharts'

const PDFPieChart = ({
  data = [],
  width = 600, // 增加圖表寬度以容納圖例
  height = 300,
  onLoaded,
}) => {
  const chartRef = useRef()
  const hasLoaded = useRef(false)

  const allZero = data.every(item => item.value === 0)

  // 自定義顏色
  const colorPalette = [
    '#d20a50ff',
    '#55059bff',
    '#1c9ec9ff',
    '#722727',
    '#2c6372',
    '#ff9900',
    '#a4c619',
    '#52b76a',
    '#f26419',
    '#2f4858',
    '#8ac926',
    '#1982c4',
    '#6a4c93',
    '#ff6b6b',
    '#e0b44eff',
    '#028b67ff',
    '#118ab2',
    '#073b4c',
    '#e63946',
    '#4c1045ff',
  ]

  // 隨機打亂顏色
  const shuffledColors = [...colorPalette].sort(() => 0.5 - Math.random())

  useEffect(() => {
    const timer = setTimeout(() => {
      if (!hasLoaded.current) {
        hasLoaded.current = true
        onLoaded?.(chartRef.current)
      }
    }, 100)

    return () => {
      clearTimeout(timer)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <div
      ref={chartRef}
      style={{
        display: 'flex',
        alignItems: 'center',
        flexDirection: 'column',
        justifyContent: 'center',
        padding: '20px',
        border: '4px solid rgb(182, 180, 180)', // 包圍整體的邊框
        width: '100%', // 確保容器的寬度足夠
        boxSizing: 'border-box', // 讓邊框也計算在內
        boxShadow: '0px 10px 30px rgba(0, 0, 0, 0.3)', // 增強陰影效果，讓陰影更為明顯
        overflow: 'hidden', // 確保陰影可見
      }}
    >
      {/* 單位標題 */}
      <div style={{ position: 'absolute', top: 10, left: 20, fontSize: 12, fontWeight: 'bold' }}>
        單位: (人)
      </div>
      {allZero === false ? (
        <PieChart width={width} height={height}>
          <Pie
            data={data}
            dataKey="value"
            nameKey="name"
            cx="40%" // 確保餅圖向左移動，給圖例留出空間
            cy="50%"
            outerRadius={100}
            label={({ name, value }) => `${name}, ${value}`}
          >
            {data.map((_, index) => (
              <Cell key={`cell-${index}`} fill={shuffledColors[index % shuffledColors.length]} />
            ))}
          </Pie>
          <Tooltip />
          {/* <Legend
          layout="vertical"
          align="right"
          verticalAlign="middle"
          wrapperStyle={{
            position: 'absolute',
            right: '0', // 使图例贴齐右边
            top: '50%', // 使图例垂直居中
            transform: 'translateY(-50%)', // 修正由于 `top: 50%` 导致的偏移
            fontSize: '14px', // 调整字体大小
          }}
          itemMargin={{ horizontal: 10, vertical: 20 }} // 调整垂直间距
        /> */}

          <Legend
            wrapperStyle={{
              position: 'relative', // 使用相对定位，确保图例在容器内定位
              width: 'auto', // 确保宽度自动调整以适应内容
              height: 'auto', // 高度自适应
              display: 'flex',
              flexDirection: 'column', // 垂直排列
              justifyContent: 'flex-start',
              alignItems: 'flex-end', // 将图例项对齐到右侧
              marginLeft: '20px', // 增加左边距，确保图例与图表的距离
              marginTop: '-200px', // 向上移动图例
              fontSize: '12px',
            }}
            content={() => (
              <ul
                style={{
                  padding: 0,
                  margin: 0,
                  listStyle: 'none',
                  textAlign: 'left', // 图例文字左对齐
                }}
              >
                {data.map((entry, index) => (
                  <li
                    key={`item-${index}`}
                    style={{
                      display: 'flex', // 使用 flex 以便颜色块和文本水平对齐
                      alignItems: 'center', // 保证颜色块和文本垂直居中
                      marginBottom: '15px', // 每个图例项之间的间距
                    }}
                  >
                    <span
                      style={{
                        display: 'inline-block',
                        width: '12px', // 确保颜色块的宽度一致
                        height: '12px', // 确保颜色块的高度一致
                        backgroundColor: shuffledColors[index % shuffledColors.length],
                        marginRight: '8px', // 颜色块和文字之间的间距
                      }}
                    ></span>
                    {entry.name}
                  </li>
                ))}
              </ul>
            )}
          />
        </PieChart>
      ) : (
        <PieChart width={width} height={height}>
          <Pie
            data={[{ name: '', value: 1 }]} // 假資料
            dataKey="value"
            cx="40%" // 確保餅圖向左移動，給圖例留出空間
            cy="50%"
            outerRadius={0}
            isAnimationActive={false}
            label={false}
          >
            <Cell fill="#e0e0e0" />
            <Label
              value="本次演練總釣中人數 : 0人"
              position="center"
              style={{ fontSize: 20, fontWeight: 'bold', fill: '#000' }}
            />
          </Pie>
        </PieChart>
      )}
    </div>
  )
}

export default PDFPieChart
